// invite_page_v1
// หน้าชวนเพื่อน — แสดง code, credit, stats, รายการ referrals
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Users, Copy, Share2, Gift, TrendingUp, Send, MessageCircle, Loader, CheckCircle, Clock, XCircle } from 'lucide-react';
import toast from 'react-hot-toast';
import API from '../api';

function useIsMobile() {
  const [m, setM] = useState(window.innerWidth < 768);
  useEffect(() => {
    const r = () => setM(window.innerWidth < 768);
    window.addEventListener('resize', r);
    return () => window.removeEventListener('resize', r);
  }, []);
  return m;
}

export default function Invite() {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    API.get('/api/me/referral-info')
      .then(({ data }) => setInfo(data))
      .catch(() => toast.error('โหลดข้อมูลไม่สำเร็จ'))
      .finally(() => setLoading(false));
  }, []);

  const referralLink = (info && info.code) ? window.location.origin + '/r/' + info.code : '';

  const copy = (text, label) => {
    navigator.clipboard.writeText(text).then(() => toast.success((label || 'คัดลอก') + 'แล้ว'));
  };

  const shareText = (info && info.code)
    ? 'มาใช้ AUTO CHATS ระบบจัดการแชทอัจฉริยะกัน! สมัครผ่านลิงก์ของฉัน: ' + referralLink
    : '';

  const shareTG = () => window.open('https://t.me/share/url?url=' + encodeURIComponent(referralLink) + '&text=' + encodeURIComponent(shareText), '_blank');
  const shareLine = () => window.open('https://line.me/R/msg/text/?' + encodeURIComponent(shareText), '_blank');
  const shareFB = () => window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(referralLink), '_blank');

  if (loading) {
    return (
      <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
        <Loader size={32} />
        <div style={{ marginTop: 12 }}>กำลังโหลด...</div>
      </div>
    );
  }

  const fmt = (n) => Number(n || 0).toLocaleString('th-TH');

  return (
    <div style={{ padding: isMobile ? 16 : 32, maxWidth: 900, margin: '0 auto', color: '#e2e8f0' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#64748b', textDecoration: 'none', marginBottom: 20, fontSize: 14 }}>
        <ArrowLeft size={16} /> กลับ
      </Link>

      <div style={{ background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)', borderRadius: 16, padding: isMobile ? 20 : 32, marginBottom: 24, color: 'white', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
            <Users size={32} />
            <h1 style={{ margin: 0, fontSize: isMobile ? 22 : 28 }}>ชวนเพื่อน รับส่วนลด</h1>
          </div>
          <p style={{ margin: 0, opacity: 0.9, fontSize: 15 }}>
            แชร์ลิงก์ — เพื่อนสมัครและจ่ายเงิน คุณได้ <b>{info?.percent ?? 10}%</b>{/* invite_percent_zero_fix_v1 */} เป็น credit ลดค่าต่ออายุครั้งถัดไป
          </p>
        </div>
        <Gift size={120} style={{ position: 'absolute', right: -20, bottom: -30, opacity: 0.15, transform: 'rotate(-15deg)' }} />
      </div>

      <div style={{ background: '#1e293b', border: '2px solid #0ea5e9', borderRadius: 12, padding: isMobile ? 20 : 24, marginBottom: 24 }}>
        <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 6 }}>💰 Credit คงเหลือ</div>
        <div style={{ fontSize: isMobile ? 36 : 48, fontWeight: 'bold', color: '#0ea5e9', lineHeight: 1 }}>
          {fmt(info && info.credit)} <span style={{ fontSize: 18, color: '#94a3b8' }}>บาท</span>
        </div>
        <div style={{ fontSize: 13, color: '#64748b', marginTop: 8 }}>
          ใช้หักอัตโนมัติเมื่อต่ออายุครั้งถัดไป
        </div>
      </div>

      <div style={{ background: '#1e293b', borderRadius: 12, padding: isMobile ? 20 : 24, marginBottom: 24 }}>
        <div style={{ fontSize: 14, color: '#94a3b8', marginBottom: 12, fontWeight: 600 }}>🔗 ลิงก์แนะนำของคุณ</div>
        <div style={{ background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: 12, display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, fontFamily: 'monospace', fontSize: isMobile ? 12 : 14, color: '#0ea5e9', wordBreak: 'break-all' }}>
          <div style={{ flex: 1 }}>{referralLink}</div>
          <button onClick={() => copy(referralLink, 'ลิงก์')} style={{ background: '#0ea5e9', color: 'white', border: 'none', borderRadius: 6, padding: '8px 12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, whiteSpace: 'nowrap' }}>
            <Copy size={14} /> คัดลอก
          </button>
        </div>

        <div style={{ fontSize: 14, color: '#94a3b8', marginBottom: 12 }}>📤 แชร์ผ่าน:</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button onClick={shareTG} style={shareBtn('#0088cc')}><Send size={16} /> Telegram</button>
          <button onClick={shareLine} style={shareBtn('#06c755')}><MessageCircle size={16} /> LINE</button>
          <button onClick={shareFB} style={shareBtn('#1877f2')}><Share2 size={16} /> Facebook</button>
        </div>

        <div style={{ marginTop: 16, padding: 12, background: '#0f172a', borderRadius: 8, fontSize: 13, color: '#94a3b8', borderLeft: '3px solid #0ea5e9' }}>
          💡 <b>โค้ดของคุณ:</b> <code style={{ color: '#0ea5e9', fontSize: 14 }}>{info && info.code}</code>
          <div style={{ marginTop: 4 }}>เพื่อนสามารถกรอกโค้ดนี้ตอนสมัครได้เลย</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)', gap: 12, marginBottom: 24 }}>
        <StatCard icon={<CheckCircle size={20} />} color="#22c55e" label="สำเร็จ" value={(info && info.stats && info.stats.credited) || 0} suffix="คน" />
        <StatCard icon={<Clock size={20} />} color="#f59e0b" label="รอ" value={(info && info.stats && info.stats.pending) || 0} suffix="คน" />
        <StatCard icon={<XCircle size={20} />} color="#94a3b8" label="ยกเลิก" value={(info && info.stats && info.stats.reverted) || 0} suffix="คน" />
        <StatCard icon={<TrendingUp size={20} />} color="#0ea5e9" label="รวมรางวัล" value={fmt((info && info.stats && info.stats.totalCredited) || 0)} suffix="บาท" />
      </div>

      <div style={{ background: '#1e293b', borderRadius: 12, padding: isMobile ? 16 : 20 }}>
        <div style={{ fontSize: 14, color: '#94a3b8', marginBottom: 16, fontWeight: 600 }}>👤 ผู้ที่คุณแนะนำ</div>
        {(!info || !info.recent_referrals || info.recent_referrals.length === 0) ? (
          <div style={{ textAlign: 'center', padding: 30, color: '#64748b' }}>
            <Users size={40} style={{ opacity: 0.3, marginBottom: 12 }} />
            <div style={{ fontSize: 14 }}>ยังไม่มีผู้แนะนำ — แชร์ลิงก์ของคุณเลย!</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {info.recent_referrals.map(r => {
              const sc = r.status === 'credited' ? '#22c55e' : r.status === 'pending' ? '#f59e0b' : '#94a3b8';
              const sl = r.status === 'credited' ? '✅ ได้รับแล้ว' : r.status === 'pending' ? '⏳ รอ payment' : '❌ ยกเลิก';
              return (
                <div key={r.id} style={{ background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: 14, display: 'flex', justifyContent: 'space-between', alignItems: isMobile ? 'flex-start' : 'center', flexDirection: isMobile ? 'column' : 'row', gap: 8 }}>
                  <div>
                    <div style={{ fontWeight: 600, color: '#e2e8f0' }}>{r.referred_name}</div>
                    <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                      {new Date(r.created_at).toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' })}
                    </div>
                  </div>
                  <div style={{ textAlign: isMobile ? 'left' : 'right' }}>
                    <div style={{ fontWeight: 600, color: sc, fontSize: 16 }}>+{fmt(r.reward_amount)} บาท</div>
                    <div style={{ fontSize: 12, color: sc, marginTop: 2 }}>{sl}</div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div style={{ height: 40 }} />
    </div>
  );
}

function shareBtn(color) {
  return { background: color, color: 'white', border: 'none', borderRadius: 8, padding: '10px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 500 };
}

function StatCard({ icon, color, label, value, suffix }) {
  return (
    <div style={{ background: '#1e293b', borderRadius: 10, padding: 16, border: '1px solid #334155' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, color, marginBottom: 8 }}>
        {icon}
        <span style={{ fontSize: 13, color: '#94a3b8' }}>{label}</span>
      </div>
      <div style={{ fontSize: 20, fontWeight: 'bold', color: '#e2e8f0' }}>
        {value} <span style={{ fontSize: 12, color: '#64748b', fontWeight: 400 }}>{suffix}</span>
      </div>
    </div>
  );
}
